<template>
  <div :class="[{ fullscreen: fullscreen }]" class="tinymce-container" :style="{ width: containerWidth }">
    <textarea :id="tinymceId" class="tinymce-textarea"></textarea>
  </div>
</template>

<script>
import plugins from './plugins'
import toolbar from './toolbar'
import { http, fileUpload } from '@admin-base/core'

export default {
  props: {
    id: {
      type: String,
      default: function () {
        return 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '')
      }
    },
    value: {
      type: String,
      default: ''
    },
    toolbar: {
      type: [Array, String],
      required: false,
      default() {
        return []
      }
    },
    menubar: {
      type: String,
      default: 'file edit insert view format table help'
    },
    height: {
      type: [Number, String],
      required: false,
      default: 360
    },
    width: {
      type: [Number, String],
      required: false,
      default: 'auto'
    }
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN',
        es: 'es_MX',
        ja: 'ja'
      }
    }
  },
  computed: {
    containerWidth() {
      const width = this.width
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        return `${width}px`
      }
      return width
    }
  },
  watch: {
    value(newVal) {
      const spanRegex = new RegExp('id="insert_empty"', 'g')
      const Item = window.tinymce.get(this.tinymceId).getContent().match(spanRegex)
      this.$emit('getEmpty', Item?.length || 0)

      if (!this.hasChange && this.hasInit) {
        this.$nextTick(() => window.tinymce.get(this.tinymceId).setContent(newVal || ''))
      }
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    if (window.tinymce) {
      this.initTinymce()
    }
  },
  deactivated() {
    if (tinymce) {
      window.tinymce.get(this.tinymceId).destroy()
    }
  },
  destroyed() {
    if (tinymce) {
      window.tinymce.get(this.tinymceId).destroy()
    }
  },
  methods: {
    init() {
      this.initTinymce()
    },
    initTinymce() {
      const pathName = window.location.pathname
      console.log('pathName', pathName)
      const _this = this
      window.tinymce.init({
        language: 'zh_CN',
        selector: `#${this.tinymceId}`,
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: this.menubar,
        plugins: plugins,
        external_plugins: {
          'kityformula-editor': pathName + 'tinymce/plugins/kityformula-editor/plugin.min.js', // 百度的数学公式
          insertEmpty: pathName + 'tinymce/plugins/insertEmpty/plugin.min.js', // 插入填空
          tiny_mce_wiris: pathName + `tinymce/plugins/@wiris/mathtype-tinymce5/plugin.min.js` // 数学公式，化学公式
        },
        htmlAllowedTags: ['.*'],
        htmlAllowedAttrs: ['.*'],
        draggable_modal: true,
        content_style: 'a {text-decoration: none; color: #70b1e7;} * {margin-block-start: 0; margin-block-end: 0}',
        // 工具栏下拉模式
        toolbar_mode: 'wrap',
        // 允许图片，表格等手动缩放
        object_resizing: true,
        imagetools_cors_hosts: ['http://10.111.80.82/', 'http://gssbh.com'],
        // 隐藏右下角技术支持
        branding: false,
        // 按tap键缩进
        nonbreaking_force_tab: true,
        // 取消默认弹出来的工具栏
        // 块引用格式
        formats: {
          blockquote: {
            block: 'p',
            styles: {
              'padding-left': '8px',
              'border-left': '4px solid #f0f0f0',
              color: '#a5a5a5'
            }
          }
        },
        // 自定义上传逻辑
        images_upload_handler: (blobInfo, success) => this.imageUpload(blobInfo, success),
        file_picker_callback: (callback) => this.fileUploadHandler(callback),
        quickbars_insert_toolbar: false,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        autosave_ask_before_unload: false,
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        nonbreaking_force_tab: true,
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
          editor.on('nodeChange change keyUp input setContent', () => {
            this.hasChange = true
            // this.$emit("input", editor.getContent());
            this.$emit('update:value', editor.getContent())
          })
        },
        setup: (editor) => {
          editor.on('FullscreenStateChanged', (e) => {
            _this.fullscreen = e.state
          })
        },
        convert_urls: false
      })
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent()
    },
    imageUpload(blobInfo, success) {
      // const forms = new FormData()
      // forms.append('file', blobInfo.blob(), blobInfo.filename())
      fileUpload(blobInfo.blob()).then((res) => {
        success(res.data?.fileUrl)
      })
    },
    fileUploadHandler(callback) {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.click()
      input.onchange = function () {
        const file = this.files[0]
        // const forms = new FormData()
        // forms.append('file', file, file.name)
        fileUpload(file).then((res) => {
          callback(res.data?.fileUrl, { title: res.data?.fileName })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}

.tinymce-container {
  ::v-deep {
    .mce-fullscreen {
      z-index: 10000;
    }
  }
}

.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}

.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}

.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}

.editor-upload-btn {
  display: inline-block;
}
</style>
